import React from 'react';
import styled from '@emotion/styled/macro';
import { SeparatorProps } from './separator.types';
import vars from '@variables';

const Separator: React.FC<SeparatorProps> = ({
  isFullWidth = false,
  className,
}) => (
  <div data-testid="separator-block" className={className}>
    <div className={`separator ${isFullWidth ? 'full-width' : ''}`} />
  </div>
);

const StyledSeparator = styled(Separator)`
  width: 100%;
  padding: ${vars.spacingL} 0;

  .separator {
    border: none;
    border-top: 1px dashed ${vars.borderGrey};
    margin: ${vars.spacingL} auto;
    width: 100%;

    &:not(.full-width) {
      @media screen and (min-width: ${vars.breakPointTablet}) {
        width: 75%;
      }

      @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
        width: 66.67%;
      }
    }
  }
`;

export default StyledSeparator;
